/**
 * Reunion-focused application configuration.
 * Reads from VITE_-prefixed environment variables (client-safe only).
 */
export const config = {
  siteName: import.meta.env.VITE_SITE_NAME || 'Goldson-Wade Reunion',
  siteDescription: import.meta.env.VITE_SITE_DESCRIPTION || 'Goldson-Wade Family Reunion 2027',
  siteUrl: import.meta.env.VITE_SITE_URL || '',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  menuConfig: import.meta.env.VITE_MENU_CONFIG || '',
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  defaultReunionSlug: import.meta.env.VITE_DEFAULT_REUNION_SLUG || 'goldson-wade-2027',
  debugMode: import.meta.env.VITE_DEBUG_MODE === 'true',
  logLevel: import.meta.env.VITE_LOG_LEVEL || 'info',
};
